// extracted by mini-css-extract-plugin
module.exports = {"preferences":"Preferences_preferences__2A8Nx"};